<template>
  <div class="batch-price-editor">
    <ykc-form ref="fromRules">
      <ykc-form-item
        :required="true"
        :label="'价格类别'"
        :class="typeList.length == 1 ? 'box-bottom' : ''">
        <div class="configCategory" v-for="(item, index) in typeList" :key="index">
          <ykc-input
            class="configCategory-input"
            v-model="item.name"
            :maxlength="5"
            :disabled="true"
            :placeholder="'请输入类别名称'"
            :class="{ error: item.errorName }"
            @blur="verifyTypes(1, index, item)">
            <template slot="prepend">类别名称</template>
          </ykc-input>
          <ykc-input
            class="power-rate-input"
            v-model="item.price"
            :maxlength="6"
            :placeholder="'请输入电费单价'"
            :class="{ error: item.errorPrice }"
            @blur="verifyTypes(2, index, item)">
            <template slot="prepend">电费</template>
            <template slot="append">元/度</template>
          </ykc-input>
          <div
            class="rules-error weight-syl el-form-item__error"
            v-if="item.errorName || item.errorPrice">
            {{ item.errorName || item.errorPrice }}
          </div>
        </div>
      </ykc-form-item>
      <ykc-form-item :required="false" :label="'价格设置'" v-show="typeList.length > 1">
        <div class="price-setting-tip">
          编辑提交后该价格时段将应用于全量所选电站，请谨慎配置！！！时段无需调整时此字段留空！！！
        </div>
        <div class="configCategory" v-for="(item, index) in timeList" :key="index">
          <ykc-icon name="reduce" @click="clickTimeDel($event, index, item)"></ykc-icon>
          <ykc-dropdown
            class="time-dropdown"
            v-model="item.startValue"
            :data="startTimeList"
            :configSet="configSet"
            :placeholder="'请选择开始时间'"
            :class="{ error: item.errorStart }"
            @focus="selectFocusTime(1, index, item)"
            @change="selectChange($event, 1)"></ykc-dropdown>
          <div class="time-line color-grey">至</div>
          <ykc-dropdown
            class="time-dropdown"
            v-model="item.endValue"
            :data="endTimeList"
            :configSet="configSet"
            :placeholder="'请选择结束时间'"
            :class="{ error: item.errorEnd }"
            @focus="selectFocusTime(2, index, item)"
            @change="selectChange($event, 2)"></ykc-dropdown>
          <ykc-dropdown
            class="type-dropdown"
            v-model="item.typeName"
            :data="typeList"
            :configSet="configSet"
            :placeholder="'请选择价格类别'"
            :class="{ error: item.errorName }"
            @change="selectChange($event, 3)"></ykc-dropdown>
          <div
            v-if="(item.errorStart || item.errorEnd || item.errorName) && typeList.length > 1"
            class="rules-error weight-syl el-form-item__error">
            {{ item.errorStart || item.errorEnd || item.errorName }}
          </div>
        </div>
        <div class="configCategory" v-show="isAddTime !== 2">
          <ykc-icon name="reduce"></ykc-icon>
          <ykc-input
            class="time-width"
            :disabled="true"
            :placeholder="'剩余时段价格统一选择'"></ykc-input>
          <ykc-dropdown
            class="power-rate-input"
            :data="typeList"
            v-model="otherTime"
            :configSet="configSet"
            :placeholder="'请选择价格类别'"
            @change="selectChange($event, 4)"></ykc-dropdown>
        </div>
        <div class="pointer bnt-width" v-show="isAddTime !== 2" @click="clickAddTime">
          <ykc-icon name="add" :class="{ disabled: false }"></ykc-icon>
          <div class="bnt-text">添加时间区间</div>
        </div>
      </ykc-form-item>
    </ykc-form>
  </div>
</template>

<script>
  import { toFixed } from '@/utils';

  export default {
    name: 'BatchPriceEditor',
    props: {
      priceData: null, // 价格数据（批量调整不传，仅保留兼容）
    },
    data() {
      return {
        otherTime: '', // 剩余时间类别值
        isAddTime: 1, // 是否可以增加时间区间 0置灰  1可点击 2隐藏
        IS_1TO4: /^\d{0,1}(\.\d{0,4})?$/, // 小数数字类  默认:小数点前1位、后4位
        configSet: { label: 'label', value: 'value' },
        typeNames: ['尖', '峰', '平', '谷'],
        timeList: [
          {
            startValue: '', // 开始时间值
            endValue: '', // 结束时间值
            typeName: '', // 选择的价格类型名称
            errorStart: '', // 校验提示-开始时间
            errorEnd: '', // 校验提示-结束时间
            errorName: '', // 校验提示-价格类型
          },
        ],
        typeList: [
          {
            name: '尖', // 价格类别名称
            price: '', // 电价
            errorName: '', // 校验提示
            errorPrice: '', // 校验提示
            label: '尖', // 选择时间区间时，显示的价格类别名称
            value: '尖', // 选择时间区间时，显示的价格类别值
          },
          {
            name: '峰', // 价格类别名称
            price: '', // 电价
            errorName: '', // 校验提示
            errorPrice: '', // 校验提示
            label: '峰', // 选择时间区间时，显示的价格类别名称
            value: '峰', // 选择时间区间时，显示的价格类别值
          },
          {
            name: '平', // 价格类别名称
            price: '', // 电价
            errorName: '', // 校验提示
            errorPrice: '', // 校验提示
            label: '平', // 选择时间区间时，显示的价格类别名称
            value: '平', // 选择时间区间时，显示的价格类别值
          },
          {
            name: '谷', // 价格类别名称
            price: '', // 电价
            errorName: '', // 校验提示
            errorPrice: '', // 校验提示
            label: '谷', // 选择时间区间时，显示的价格类别名称
            value: '谷', // 选择时间区间时，显示的价格类别值
          },
        ],
        endTimeList: [], // 结束时间集合
        startTimeList: [], // 开始时间集合
      };
    },
    watch: {
      priceData: {
        handler() {
          this.setData();
        },
        deep: true,
        immediate: true,
      },
    },
    mounted() {
      this.startTimeList = this.timeInit(1);
      this.endTimeList = this.timeInit(0);
    },

    methods: {
      init() {
        this.timeList = [
          {
            startValue: '', // 开始时间值
            endValue: '', // 结束时间值
            typeName: '', // 选择的价格类型名称
            errorStart: '', // 校验提示-开始时间
            errorEnd: '', // 校验提示-结束时间
            errorName: '', // 校验提示-价格类型
          },
        ];
        this.isAddTime = 1;
      },
      /**
       * 回填数据
       */
      setData() {
        if (this.priceData) {
          this.init();
          const type = this.priceData.feeList || [];
          const time = this.priceData.priceList || [];
          if (type.length === 1) {
            this.setTypeList(type, 0);
          } else {
            for (let i = 0; i < type.length; i++) {
              this.setTypeList(type, i);
            }
            if (time.length === 1) {
              this.setTimeList(time, 0, 0);
              this.isAddTime = 2;
            } else {
              this.isAddTime = 1;
              let j = 0;
              for (let i = 0; i < time.length; i++) {
                if (time[i].defaultFlag === '0') {
                  if (j !== 0) {
                    this.addTimeList();
                  }
                  this.setTimeList(time, i, j);
                  j++;
                } else {
                  this.otherTime = this.typeList[time[i].feeType - 1].name;
                  this.isAddTime = 1;
                }
              }
            }
          }
        }
      },
      /**
       * 给价格类别项赋值
       */
      setTypeList(item, index) {
        Object.assign(this.typeList[index], {
          name: this.typeNames[index],
          price: item[index].powerRate,
          value: this.typeNames[index],
          label: `${this.typeList[index].name}：电费【${item[index].powerRate}元】`,
        });
      },
      /**
       * 增加时间区间
       */
      addTimeList() {
        const obj = {
          startValue: '', // 开始时间值
          endValue: '', // 结束时间值
          typeName: '', // 选择的价格类型名称
          errorStart: '', // 校验提示-开始时间
          errorEnd: '', // 校验提示-结束时间
          errorName: '', // 校验提示-价格类型
        };
        this.timeList.push(obj);
      },
      /**
       * 给时间区间项赋值
       */
      setTimeList(item, index, key) {
        this.timeList[key].startValue = Number(item[index].priceStartPeriod);
        this.timeList[key].endValue = Number(item[index].priceEndPeriod);
        this.timeList[key].typeName = this.typeList[item[index].feeType - 1].name;
      },
      /**
       * 初始化时间格式 48个时段
       */
      timeInit(type) {
        const timeBlock = [];
        for (let i = 0; i < 49; i++) {
          let a = 1;
          let b = 0;
          let label = '';
          let value = 0;
          let temp = {};
          a = Math.floor(i / 2);
          a = a > 9 ? a.toString() : `0${a}`;
          b = (i % 2) * 30;
          b = b === 30 ? b.toString() : `${b}0`;

          label = `${a}:${b}`;
          value = i;

          if (type === 0) {
            temp = {
              label,
              value: value + 1,
              disabled: i === 0,
            };
          } else {
            temp = {
              label,
              value: value + 1,
              disabled: i === 48,
            };
          }
          timeBlock[i.toString()] = temp;
        }
        return timeBlock;
      },
      /**
       * 校验价格类别
       */
      verifyType(name, verify, msgNull, msgVerify) {
        if (!name) {
          return msgNull;
        }
        if (!verify.test(name)) {
          return msgVerify;
        }
        return '';
      },
      /**
       * 校验价格类型
       */
      verifyTypes(type, index, item) {
        if (item) {
          if (type === 2) {
            item.errorPrice = this.verifyType(
              item.price,
              this.IS_1TO4,
              '请输入电费',
              '请输入正确的电费（范围：0.0000~9.9999）'
            );
            if (item.price && !item.errorPrice) {
              item.price = toFixed(item.price, 4);
            }
          }
          if (!item.errorName) {
            item.value = item.name;
          }
          item.label = `${item.name}：电费【${item.price}元】`;
          this.$set(this.typeList, index, item);
        } else {
          for (let i = this.typeList.length - 1; i >= 0; i--) {
            const items = this.typeList[i];
            items.errorPrice = this.verifyType(
              items.price,
              this.IS_1TO4,
              '请输入电费',
              '请输入正确的电费（范围：0.0000~9.9999）'
            );
          }
        }
      },
      /**
       * 判断价格类型是否校验通过
       */
      isType() {
        let flag = true;
        for (let i = this.typeList.length - 1; i >= 0; i--) {
          const item = this.typeList[i];
          if (!item.name || !item.price || item.errorName || item.errorPrice) {
            flag = false;
            break;
          }
        }
        return flag;
      },
      /**
       * 开始下拉选择时间区间
       */
      selectFocusTime(type, index, item) {
        if (type === 1) {
          for (let i = 0; i < 48; i++) {
            this.startTimeList[i].disabled = false;
          }
          if (item.endValue) {
            for (let i = item.endValue - 1; i < 48; i++) {
              this.startTimeList[i].disabled = true;
            }
          }
          for (let i = 0; i < this.timeList.length; i++) {
            const tmp = this.timeList[i];
            if (i !== index) {
              if (item.endValue && item.endValue > tmp.endValue) {
                for (let j = 0; j < tmp.endValue - 1; j++) {
                  this.startTimeList[j].disabled = true;
                }
              } else {
                for (let j = tmp.startValue - 1; j < tmp.endValue - 1; j++) {
                  this.startTimeList[j].disabled = true;
                }
              }
            }
          }
        } else {
          for (let i = 1; i < 49; i++) {
            this.endTimeList[i].disabled = false;
          }
          if (item.startValue) {
            for (let i = 1; i < item.startValue; i++) {
              this.endTimeList[i].disabled = true;
            }
          }
          for (let i = 0; i < this.timeList.length; i++) {
            const tmp = this.timeList[i];
            if (i !== index) {
              if (item.startValue && item.startValue < tmp.startValue) {
                for (let j = tmp.startValue; j < 49; j++) {
                  this.endTimeList[j].disabled = true;
                }
              } else {
                for (let j = tmp.startValue; j < tmp.endValue; j++) {
                  this.endTimeList[j].disabled = true;
                }
              }
            }
          }
        }
      },
      /**
       * 选项时间区间和类别时事件-校验
       */
      selectChange(evt, type) {
        if (type < 4) {
          this.verifyTime();
        }
      },
      /**
       * 校验时间区间
       */
      verifyTime(isMsg) {
        let flag = true;
        for (let i = 0; i < this.timeList.length; i++) {
          const item = this.timeList[i];
          if (item.startValue) {
            item.errorStart = '';
          } else if (!item.startValue) {
            flag = false;
            if (isMsg) {
              item.errorStart = '请选择开始时间';
            } else {
              break;
            }
          }
          if (item.endValue) {
            item.errorEnd = '';
          } else if (!item.endValue) {
            flag = false;
            if (isMsg) {
              item.errorEnd = '请选择结束时间';
            } else {
              break;
            }
          }
          if (item.typeName) {
            item.errorName = '';
          } else if (!item.typeName) {
            flag = false;
            if (isMsg) {
              item.errorName = '请选择价格类型';
            } else {
              break;
            }
          }
        }

        const arr = [];
        for (let i = 0; i < this.timeList.length; i++) {
          const item = this.timeList[i];
          for (let j = item.startValue; j < item.endValue; j++) {
            arr.push(j);
          }
        }
        if (arr.length === 48) {
          this.isAddTime = 2;
        } else {
          this.isAddTime = 0;
          if (!this.otherTime) {
            this.otherTime = this.typeList[0].name;
          }
        }

        if (this.isAddTime !== 2) {
          this.isAddTime = flag ? 1 : 0;
        }
      },
      /**
       * 判断时间区间是否校验通过
       */
      isTime() {
        let flag = true;
        if (this.typeList.length > 1) {
          const hasSetting = this.timeList.some(
            item => item.startValue || item.endValue || item.typeName
          );
          if (!hasSetting) {
            return true;
          }
          for (let i = this.timeList.length - 1; i >= 0; i--) {
            const item = this.timeList[i];
            if (
              !item.startValue ||
              !item.endValue ||
              !item.typeName ||
              item.errorStart ||
              item.errorEnd ||
              item.errorName
            ) {
              flag = false;
              break;
            }
          }
        }

        return flag;
      },
      /**
       * 添加时间区间
       */
      clickAddTime() {
        this.verifyTime(true);
        if (this.isAddTime === 1) {
          this.addTimeList();
          this.isAddTime = 0;
        }
      },
      /**
       * 删除时间区间
       */
      clickTimeDel(evt, index, item) {
        if (index === 0 && item.startValue === 1 && item.endValue === 49) {
          return;
        }
        if (this.timeList.length > 1) {
          this.timeList.splice(index, 1);
        }
        if (this.isAddTime !== 1) {
          this.isAddTime = 1;
        }
      },
      saveVerifyOMP() {
        this.verifyTypes();
        this.verifyTime(true);
        let obj = null;
        if (this.isType() && this.isTime()) {
          obj = {};
          obj.feeList = [];

          this.typeList.forEach((item, index) => {
            obj.feeList.push({
              feeType: index + 1,
              priceTypeName: item.name,
              powerRate: Number(item.price),
              stationFeeId: '',
            });
          });

          obj.priceList = [];

          if (this.typeList.length > 1) {
            const hasSetting = this.timeList.some(
              item => item.startValue || item.endValue || item.typeName
            );
            if (hasSetting) {
              this.timeList.forEach(item => {
                this.typeList.forEach((item1, index1) => {
                  if (item.typeName === item1.name) {
                    obj.priceList.push({
                      defaultFlag: '0',
                      priceStartPeriod: item.startValue,
                      priceEndPeriod: item.endValue,
                      feeType: index1 + 1,
                      powerRate: Number(item1.price),
                      stationPriceId: '',
                    });
                  }
                });
              });

              if (this.isAddTime !== 2) {
                this.typeList.forEach((item, index) => {
                  if (this.otherTime === item.name) {
                    obj.priceList.push({
                      defaultFlag: '1',
                      priceStartPeriod: 0,
                      priceEndPeriod: 0,
                      feeType: index + 1,
                      powerRate: Number(item.price),
                      stationPriceId: '',
                    });
                  }
                });
              }
            }
          } else {
            obj.priceList.push({
              defaultFlag: '0',
              priceStartPeriod: 1,
              priceEndPeriod: 49,
              feeType: 1,
              powerRate: Number(this.typeList[0].price),
              stationPriceId: '',
            });
          }
        }
        return obj;
      },
    },
  };
</script>

<style lang="scss">
  .batch-price-editor {
    .configCategory {
      width: 100%;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 16px;

      ::v-deep .error {
        border-color: #f56c6c !important;

        &:focus {
          border-color: #f56c6c !important;
        }
      }

      .ykc-icon-reduce {
        height: 16px;
        margin-top: 7px;
        margin-right: 8px;
        cursor: pointer;
        text-align: right;
        color: var(--theme-color-primary);

        &.disabled {
          color: #d7d7d7;
          cursor: not-allowed;
        }
      }

      .configCategory-input {
        width: 130px;
      }

      .power-rate-input {
        width: 250px;
        margin: 0 8px;
      }

      .time-dropdown {
        width: 120px;
      }

      .type-dropdown {
        width: 250px;
        margin-left: 8px;
      }

      .time-width {
        width: 250px;
      }
    }

    .pointer {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: flex-start;

      .ykc-icon-add {
        height: 16px;
        margin-top: 1px;
        margin-right: 8px;
        cursor: pointer;
        text-align: right;
        font-size: 15px;
        color: var(--theme-color-primary);

        &.disabled {
          color: #d7d7d7;
          cursor: not-allowed;
        }
      }

      .bnt-text {
        cursor: pointer;
        font-size: 14px;
        color: var(--theme-color-primary);
      }
    }

    .time-line {
      margin: 0 6.5px;
    }

    .price-setting-tip {
      color: #f56c6c;
      font-size: 12px;
      margin-bottom: 12px;
      line-height: 1.5;
    }
  }
</style>
